(() => {
  'use strict';
  const A=window.AE;
  A.q=(selector,root=document)=>root.querySelector(selector);
  A.qa=(selector,root=document)=>[...root.querySelectorAll(selector)];
  A.text=key=>A.copy[key]||key;
  A.escape=value=>String(value??'').replace(/[&<>"']/g,char=>({'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;'}[char]));
  const money=new Intl.NumberFormat(A.locale||'en-AU',{style:'currency',currency:A.currency||'AUD',currencyDisplay:'narrowSymbol'});
  A.money=value=>money.format(Number(value??0)/100);
  A.url=path=>new URL((A.root||'/').replace(/\/$/,'')+'/'+String(path).replace(/^\//,''),location.origin);
  A.request=async(url,options={})=>{
    const cartRead=(options.method||'GET').toUpperCase()==='GET'&&/\/cart\.js$/.test(new URL(String(url),location.origin).pathname);
    const controller=cartRead&&!options.signal?new AbortController():null;
    const timer=controller?setTimeout(()=>controller.abort(),10000):null;
    try{
      const response=await fetch(String(url),{credentials:'same-origin',...options,...(controller?{signal:controller.signal}:{})});
      const data=await response.json();
      if(!response.ok){const error=new Error(data.description||data.message||A.text('cart_error'));error.status=response.status;throw error;}
      return data;
    }catch(error){if(controller?.signal.aborted)throw new Error(A.text('cart_delay'));throw error;}
    finally{if(timer)clearTimeout(timer);}
  };
  A.feedback=(button,label)=>{
    const html=button.innerHTML,variant=button.dataset.variantId,aria=button.getAttribute('aria-label'),busy=button.getAttribute('aria-busy');
    button.setAttribute('aria-busy','true');
    if(new URLSearchParams(location.search).get('ae_cart_debug')==='1')console.info('[Allure cart] '+JSON.stringify({stage:'button-feedback',ms:Math.round(performance.now())}));
    if(label){button.textContent=label;button.setAttribute('aria-label',label);}
    return()=>{
      if(label){if(variant===button.dataset.variantId)button.innerHTML=html;else button.textContent=A.text(button.dataset.variantAvailable==='false'?'sold_out':'add_to_bag');if(aria===null)button.removeAttribute('aria-label');else button.setAttribute('aria-label',aria);}
      if(busy===null)button.removeAttribute('aria-busy');else button.setAttribute('aria-busy',busy);
    };
  };
  let toastTimer;
  A.toast=message=>{
    const toast=A.q('#jBar-toast');if(!toast)return;
    clearTimeout(toastTimer);toast.classList.add('epic-feedback');
    const text=toast.querySelector('.jBar-toast-text');if(text)text.textContent=message;
    toast.style.display='flex';toastTimer=setTimeout(()=>{toast.style.display='none';},5000);
  };
  A.enhance=root=>A.cart?.syncCards(root);
})();
